import { WeddingSearch } from "@/components/ui/wedding-search";
export const HeroContent = () => {
  return <div className="relative z-[5] px-4 sm:px-8 lg:px-[147px] pt-8 sm:pt-16 lg:pt-[120px] pb-12 sm:pb-16 lg:pb-20">
      <div className="max-w-full text-center">
        <h1 className="max-w-[594px] lg:max-w-none mx-auto text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight sm:leading-[50px] lg:leading-[60px] mb-6 sm:mb-10 lg:mb-[40px] mt-3 text-white">Planera ert bröllop – hitta lokaler, leverantörer och inspiration</h1>
        
        <div className="max-w-4xl mx-auto">
          <WeddingSearch showTitle={false} />
        </div>
      </div>
    </div>;
};